import {z} from 'zod'
import {mapMinutesOfDay} from './mapper/mapMinutesOfDay.js'
import {Time} from './Time.js'

export const TimeRange = z
  .object({
    start: Time,
    end: Time,
  })
  .check((ctx) => {
    if (mapMinutesOfDay(ctx.value.start) > mapMinutesOfDay(ctx.value.end)) {
      ctx.issues.push({
        input: ctx.value,
        path: ['start'],
        code: 'custom',
        message: `Start is after end`,
      })
      ctx.issues.push({
        input: ctx.value,
        path: ['end'],
        code: 'custom',
        message: `End is before start`,
      })
    }
  })
export type TimeRange = z.infer<typeof TimeRange>
